import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import QuoteForm from "@/components/QuoteForm";
import IleDeFranceMap from "@/components/IleDeFranceMap";
import { CONTACT } from "@/data/site";

export default function Contact() {
  const items = [
    { icon: Phone, label: "Téléphone", value: CONTACT.phoneDisplay, href: `tel:${CONTACT.phoneTel}` },
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: "Zone", value: CONTACT.zone },
    { icon: Clock, label: "Horaires", value: CONTACT.hours },
  ];

  return (
    <>
      <Seo
        title="Devis Gratuit Recherche de Fuite d'Eau | FuiteX"
        description="Demandez votre devis gratuit de recherche de fuite d'eau en Île-de-France. Réponse rapide, intervention sous 24 à 48h. Appel ou formulaire en ligne."
        canonical="/contact"
      />
      <PageHero
        overline="Contact / Devis"
        titleLines={["Demandez votre", "devis gratuit"]}
        subtitle="Décrivez votre situation en quelques clics : nous vous recontactons rapidement pour organiser l'intervention."
        breadcrumb={[{ label: "Contact" }]}
      />

      <section className="bg-white py-24">
        <div className="container-x grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="mb-8 overflow-hidden rounded-3xl border border-ink/10">
                <img src="/images/fuitex-office.jpg" alt="Accueil FuiteX - contact recherche de fuite d'eau" className="w-full h-auto object-cover" />
              </div>
              <h2 className="text-2xl font-bold tracking-tight text-ink">Nos coordonnées</h2>
              <p className="mt-3 text-ink/70">Une fuite active ? Appelez-nous directement, nous privilégions les urgences.</p>
              <div className="mt-8 space-y-4">
                {items.map((it) => {
                  const Cmp = it.href ? "a" : "div";
                  return (
                    <Cmp
                      key={it.label}
                      {...(it.href ? { href: it.href, "data-testid": `contact-${it.label.toLowerCase()}` } : {})}
                      className="flex items-start gap-4 rounded-2xl border border-ink/10 p-5 hover:border-aqua/40 transition-colors"
                    >
                      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-aqua/10 text-aqua shrink-0">
                        <it.icon size={20} />
                      </span>
                      <span>
                        <span className="block text-xs font-bold uppercase tracking-wide text-ink/40">{it.label}</span>
                        <span className="block text-base font-semibold text-ink mt-0.5">{it.value}</span>
                      </span>
                    </Cmp>
                  );
                })}
              </div>

              <div className="mt-8 rounded-3xl bg-ink p-6 grain relative overflow-hidden">
                <div className="relative z-10">
                  <p className="overline text-aqua mb-4">Notre couverture</p>
                  <IleDeFranceMap />
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15} className="lg:col-span-7">
            <QuoteForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
